import React, { useEffect, useState } from 'react'
import { Divider } from '@fs/zion-ui'
import { Link, useLocation } from '@fs/zion-router'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import useNavLinks from '../hooks/useNavLinks'

const navBarCss = css`
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  white-space: nowrap;
  scroll-behavior: smooth;
  line-height: 2.5rem;
  margin-inline-start: 10px;

  /* Hide menu when printing */
  @media print {
    display: none;
  }
`

const spanCss = css`
  font-family: Verdana, Ayuthaya, sans-serif;
  color: #000000;
  text-decoration: none;
  background: transparent;
  border-radius: 4px;
  border: 0;
  cursor: pointer;
  font-size: 14px;
  margin-inline-end: 5px;
  padding: 4px 10px;
  vertical-align: middle;

  [lang|='zh'] &,
  [lang|='ja'] &,
  [lang|='ko'] & {
    font-size: 16px;
  }

  &:hover {
    background: #e1edc1;
    text-decoration: underline; /* required or else the <a> tag will underline with a color */
  }
  &:focus {
    outline: none;
  }
  &[is-selected] {
    background: #e1edc1;
  }
`

const getDefaultIndex = (pathname) => {
  // this array helps us find out which nav link is selected or highlighted
  const helpPages = ['/landing', '/classes-and-videos', '/community-landing', '/one-on-one']
  return Math.max(
    helpPages.findIndex((page) => pathname.includes(page)),
    0
  )
}
// helpPages.findIndex((page) => pathname.includes(page))
function NavLink({ path, name, external, index, selectedIndex, setSelectedIndex, dataTestId }) {
  return (
    <Link to={path} external={external} onClick={() => setSelectedIndex(index)} data-testid={dataTestId}>
      <span css={spanCss} index={index} is-selected={boolAttr(selectedIndex === index)}>
        {name}
      </span>
    </Link>
  )
}

export default function NavigationTabs() {
  const { pathname } = useLocation()
  const navLinks = useNavLinks(pathname)
  // Books and Wiki are hidden for CJK languages at the request of FS CJK specialists

  const [selectedIndex, setSelectedIndex] = useState(() => getDefaultIndex(pathname))

  useEffect(() => {
    setSelectedIndex(getDefaultIndex(pathname))
  }, [pathname])

  function navLink({ path, name, index, external = true, dataTestId }) {
    return (
      <NavLink
        path={path}
        name={name}
        index={index}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        external={external}
        dataTestId={dataTestId}
        key={dataTestId}
      />
    )
  }

  return navLinks?.length ? (
    <>
      <nav css={navBarCss}>
        {navLinks.map((link) => {
          return navLink(link)
        })}
      </nav>
      <Divider />
    </>
  ) : null
}
